import { render, staticRenderFns } from "./MapaStatus.vue?vue&type=template&id=524ab4a0"
import script from "./MapaStatus.vue?vue&type=script&lang=js"
export * from "./MapaStatus.vue?vue&type=script&lang=js"
import style0 from "./MapaStatus.vue?vue&type=style&index=0&id=524ab4a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports